import {
  DocumentationCategory,
  DocumentationCategoryFilterInputObject,
  EdmDocumentationCategoriesQueryVariables,
  useEdmDocumentationCategoriesQuery,
} from 'graphql-common';
import _get from 'lodash/get';
import { GetUrlParams } from '@lib/enums/urls';
import createSearchFilters from '@lib/utils/createSearchFilters';
import { ListQueryHookProps, ListQueryHookResult } from '../types';

export default function useEdmDocumentationCategoriesQueryHook({
  paginationParams,
  searchQuery,
  skip,
  usePrevious = true,
  fetchPolicy = 'cache-and-network',
}: ListQueryHookProps): ListQueryHookResult<DocumentationCategory> {
  const page = _get(paginationParams, GetUrlParams.Page);
  const perPage = _get(paginationParams, GetUrlParams.PerPage);
  const orderingField = _get(paginationParams, GetUrlParams.OrderingField);
  const orderingDirection = _get(
    paginationParams,
    GetUrlParams.OrderingDirection,
  );
  const queryVariables: EdmDocumentationCategoriesQueryVariables = {
    page: Number(page),
    limit: Number(perPage),
  };
  if (orderingField && orderingDirection) {
    queryVariables.sorts = {
      [orderingField]: orderingDirection,
    };
  }
  const filters: DocumentationCategoryFilterInputObject[] = [];
  if (searchQuery) {
    filters.push(...createSearchFilters(searchQuery, [{ fieldName: 'name' }]));
  }
  if (filters.length) {
    queryVariables.filters = filters;
  }
  const query = useEdmDocumentationCategoriesQuery({
    fetchPolicy,
    variables: queryVariables,
    skip,
  });
  const { loading, data, previousData, error, refetch } = query;
  const queryData = usePrevious ? data || previousData : data;
  const firstLoading = loading && previousData === undefined;
  const collection =
    !usePrevious && loading
      ? []
      : (_get(queryData, 'data.collection', []) as DocumentationCategory[]);
  const metadata = _get(queryData, 'data.metadata');
  const totalCount = _get(metadata, 'totalCount', 0);
  const totalPages = _get(metadata, 'totalPages', 0);

  return {
    collection,
    error,
    firstLoading,
    loading,
    refetch,
    totalCount,
    totalPages,
  };
}
